/**
 * @generated SignedSource<<224ebd1da0b4cafa32245c8f7d5fa171>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotesCastPanelOwnVotesFragment$data = {
  readonly delegate?: {
    readonly votes: ReadonlyArray<{
      readonly proposal: {
        readonly id: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"VoteRowFragment">;
    }>;
  };
  readonly " $fragmentType": "VotesCastPanelOwnVotesFragment";
};
export type VotesCastPanelOwnVotesFragment$key = {
  readonly " $data"?: VotesCastPanelOwnVotesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VotesCastPanelOwnVotesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "VotesCastPanelOwnVotesFragment",
  "selections": [
    {
      "condition": "skipAddress",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "addressOrEnsName",
              "variableName": "address"
            }
          ],
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "delegate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Vote",
              "kind": "LinkedField",
              "name": "votes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OnChainProposal",
                  "kind": "LinkedField",
                  "name": "proposal",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VoteRowFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "25324b581c24e21e4bec733770946f48";

export default node;
